import { z } from 'zod';

export const table = {
    string: z.string({ message: '' }).trim(),
    number: z.number({ message: '' }),
    boolean: z.boolean({ message: '' }),
    date: z.date({ message: '' }),
    datetime: z.date({ message: '' }),
    time: z.date({ message: '' }),
    attachment: z.object({ id: z.string({ message: '' }) }),
};

export const tableHelpers = {
    getMinMaxNumber: (min: number, max?: number) => {
        const schema = table.number.min(min, { message: '' });

        if (max) return schema.max(max, { message: '' });

        return schema;
    },
};
